import { mapFillStyleTo } from '@ff-os/rendering-shared/coloring';
import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { Json } from '@ff-os/shared-json/Json';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { LoadableShape } from 'ff-canvas';
import { EngravingVariableInput } from './EngravingVariableInput';
import { EngravingVariableOptions } from './EngravingVariableOptions';

export const engravingToFfCanvas = (
    variable: GiftJson.Variable<EngravingVariableOptions>,
    input: EngravingVariableInput,
    palette: Json.Palette,
    target: PaintTarget,
    jwt: string | null
): LoadableShape | LoadableShape[] => {

    if (!input.assetUrl) {
        return [];
    }

    return {

        id: variable.id,
        type: 'loadable-shape',
        round: true,

        url: input.assetUrl,

        x: variable.x,
        y: variable.y,
        width: variable.width,
        height: variable.height,
        zIndex: variable.zIndex,
        angle: 0,

        scaleX: 1,
        scaleY: 1,
        alpha: input.alpha,

        fillStyle: mapFillStyleTo(target, input, variable.options, palette),

        shadow: input.shadow,
        shadowBlur: input.shadowBlur,
        shadowColor: input.shadowColor,
        shadowOffsetX: input.shadowOffsetX,
        shadowOffsetY: input.shadowOffsetY,

        stroke: input.stroke,
        strokeSize: input.strokeSize,
        strokeStyle: input.strokeStyle,

        custom: {
            watch: [],
            values: {}
        }
    };
};